/* istanbul ignore file */
import React from 'react';

function IconChevronLeft() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "icon-chevron-left",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      width: 10
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "polyline",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "23.7,30.9 8.8,16 23.7,1.1 "
  }));
}

export default IconChevronLeft;